export function iconPath(name) {
  return `/img/icons/${name}`;
}

export function categoryImagePath(name) {
  return name ? `/img/categories/${name}` : '';
}

export function wordImagePath(name) {
  return name ? `/img/words/${name}` : '';
}
